import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { getImageList } from '../../utils/functions';
import ImageSliderModal from '../ImageSliderModal';
import IconArrow from '../svg/IconArrow';

const GallerySection = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);

  const initialImageCount = 12;

  useEffect(() => {
    const loadImages = async () => {
      setIsLoading(true);
      try {
        const imageList = getImageList(25);
        setImages(imageList);
      } catch (error) {
        console.error('이미지 로딩 실패:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadImages();
  }, []);

  const openModal = (index) => {
    setCurrentImageIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleToggleShow = () => {
    setShowAll(!showAll);
  };

  const displayedImages = showAll ? images : images.slice(0, initialImageCount);

  return (
    <StyledSection>
      <h2>갤러리</h2>
      <StyledUl>
        {displayedImages.map((image, index) => (
          <li key={image.id}>
            <button type="button" onClick={() => openModal(index)}>
              <img
                src={image.image}
                alt={`갤러리 이미지 ${image.id}`}
                loading="lazy"
              />
            </button>
          </li>
        ))}
      </StyledUl>

      {images.length > initialImageCount && (
        <StyledButton
          type="button"
          onClick={handleToggleShow}
          showAll={showAll}
        >
          {showAll ? '접기' : '더보기'} <IconArrow />
        </StyledButton>
      )}

      <ImageSliderModal
        isOpen={modalOpen}
        onClose={closeModal}
        images={images}
        initialSlideIndex={currentImageIndex}
      />
    </StyledSection>
  );
};

const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  padding: 4rem 0;
  text-align: center;

  & > h2 {
    margin-bottom: 3rem;
    font-size: 1.8rem;
    line-height: 2.4rem;
    font-weight: 600;
  }
`;

const StyledUl = styled.ul`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;
  padding: 0 0.5rem;

  & > li {
    aspect-ratio: 1 / 1;
    border-radius: 0.5rem;
    overflow: hidden;

    button {
      width: 100%;
      height: 100%;
      padding: 0;
      border: none;
      background: none;
      cursor: pointer;
      transition: transform 0.2s ease;

      &:hover {
        transform: scale(1.03);
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;

const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--pretendard);
  font-size: 1.4rem;
  line-height: 1.6rem;
  color: var(--grayLv3);
  width: fit-content;
  margin: 2rem auto 0;
  padding: 0.8rem 1.2rem;
  transition: color 0.2s ease;

  svg {
    width: 1.6rem;
    height: 1.6rem;
    transition: transform 0.2s ease;

    & > path {
      fill: var(--grayLv3);
      transition: fill 0.2s ease;
    }

	${({ showAll }) =>
    showAll &&
    `
	    transform: rotate(180deg);
    `}
  }

  &:hover {
    color: var(--surface);

    path {
		fill: var(--surface);
	}
`;

export default GallerySection;
